var map = {
	"./hero/styles": [
		5831,
		831
	],
	"./joyland/styles": [
		9627,
		627
	],
	"./little-donkey/styles": [
		910,
		910
	],
	"./luca/styles": [
		8563,
		563
	],
	"./magnolia-point/styles": [
		9406,
		406
	],
	"./pihakis/styles": [
		556,
		556
	],
	"./psito/styles": [
		3,
		3
	],
	"./rodney-scotts/styles": [
		1811,
		811
	],
	"./tasty-town/styles": [
		8647,
		647
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5521;
module.exports = webpackAsyncContext;